import { Vehicle } from "../../DataStructures/Vehicle/Vehicle";
import { VehicleReservation } from "../../DataStructures/VehicleReservation/VehicleReservation";

export class AvailableVehicles{

    private vehicleReservations : Array<VehicleReservation> = new Array<VehicleReservation>();
    private removedReservations : Array<VehicleReservation> = new Array<VehicleReservation>();

    constructor(reservations:Array<VehicleReservation>){
        this.vehicleReservations = reservations;
    }

    addReservations(reservations:Array<VehicleReservation>){

        this.vehicleReservations = this.vehicleReservations.concat(reservations);
    }

    getVehicles() : Array<Vehicle>{

        var vehicles = [];
        this.vehicleReservations.forEach(x => vehicles.push(x.vehicle));
        return vehicles;
    }

    removeVehicle(vehicleId){

        var reservationWithVehicleToRemove = this.vehicleReservations.find(vr => vr.vehicle.vehicleid == vehicleId);
        var index = this.vehicleReservations.indexOf(reservationWithVehicleToRemove);
        if(index != -1){
            this.removedReservations.push(this.vehicleReservations.splice(index,1)[0]);
        }
    }

    getReservations():Array<VehicleReservation>{
        return this.vehicleReservations;
    }

    getReservationForVehicle(vehicleId):VehicleReservation{

        var r = this.vehicleReservations.find(vr => vr.vehicle.vehicleid == vehicleId);
        if(r == null){
            return this.removedReservations.find(vr => vr.vehicle.vehicleid == vehicleId);
        }else{
            return r;
        }
    }
}